var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_vm.displayLoading ? _c('div', [_c('Loading')], 1) : _vm._e(), _c('div', {
    staticClass: "page"
  }, [_c('div', {
    staticClass: "page__title"
  }, [_vm._v(" " + _vm._s(_vm.moduleConfig.carrier_page ? _vm.moduleConfig.carrier_page.form_title : '輸入載具發票資訊') + " ")]), _vm.moduleConfig.carrier_page ? _c('div', {
    staticClass: "page__desc"
  }, [_vm._v(" " + _vm._s(_vm.moduleConfig.carrier_page && _vm.moduleConfig.carrier_page.form_desc))]) : _vm._e(), _c('div', {
    staticClass: "form"
  }, [_c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "field__label",
    class: 'field--required'
  }, [_vm._v("手機/載具條碼")]), _c('div', {
    staticClass: "d-flex align-items-center s-space-x-3"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.card_no,
      expression: "card_no"
    }],
    staticClass: "field__input",
    class: {
      invalid: _vm.v$.card_no.$error
    },
    attrs: {
      "placeholder": ""
    },
    domProps: {
      "value": _vm.card_no
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) { return; }
        _vm.card_no = $event.target.value;
      }
    }
  }), _c('b-badge', {
    staticClass: "px-2",
    attrs: {
      "variant": _vm.varifyBadgeVariant
    }
  }, [_vm._v(" " + _vm._s(_vm.varifyMessage) + " ")])], 1), _c('small', {
    staticClass: "field__desc"
  }, [_vm._v("範例：/AB-82CQ")]), _vm.v$.card_no.$error ? _c('div', {
    staticClass: "form__error-msg"
  }, [_vm._v(" 手機/載具條碼有誤或未填寫，請確認 ")]) : _vm._e()]), _vm.showCardEncrypt ? _c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "field__label",
    class: 'field--required'
  }, [_vm._v("手機/載具驗證碼")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.card_encrypt,
      expression: "card_encrypt"
    }],
    staticClass: "field__input",
    class: {
      invalid: _vm.v$.card_encrypt.$error
    },
    attrs: {
      "type": "password",
      "placeholder": ""
    },
    domProps: {
      "value": _vm.card_encrypt
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) { return; }
        _vm.card_encrypt = $event.target.value;
      }
    }
  }), _vm.v$.card_encrypt.$error ? _c('div', {
    staticClass: "form__error-msg"
  }, [_vm._v(" 手機/載具驗證碼有誤或未填寫，請確認 ")]) : _vm._e()]) : _vm._e(), _c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "field__label",
    class: 'field--required'
  }, [_vm._v("手機/載具驗類型")]), _c('SharedSelect', {
    class: {
      invalid: _vm.v$.card_type.$error
    },
    attrs: {
      "options": _vm.card_type_options
    },
    model: {
      value: _vm.card_type,
      callback: function callback($$v) {
        _vm.card_type = $$v;
      },
      expression: "card_type"
    }
  }), _vm.v$.card_type.$error ? _c('div', {
    staticClass: "form__error-msg"
  }, [_vm._v(" 資料有誤或未選擇，請確認 ")]) : _vm._e()], 1), _vm._l(_vm.terms, function (term, index) {
    return _c('div', {
      key: index,
      staticClass: "field",
      class: index == 0 ? 's-mb-8' : ''
    }, [_c('Accordion', {
      attrs: {
        "title": term.title
      }
    }, [_c('div', {
      domProps: {
        "innerHTML": _vm._s(term.content)
      }
    })]), _c('Checkbox', {
      attrs: {
        "name": 'checkbox' + index
      },
      model: {
        value: _vm.checked[index],
        callback: function callback($$v) {
          _vm.$set(_vm.checked, index, $$v);
        },
        expression: "checked[index]"
      }
    }, [_vm._v("已詳閱使用須知並同意相關使用說明")])], 1);
  })], 2)]), _c('div', {
    staticClass: "page__button"
  }, [_c('SharedButton', {
    staticClass: "s-btn-bg-primary",
    attrs: {
      "disabled": !_vm.isAllChecked
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("送出")])], 1), _vm.showReset ? _c('div', {
    staticClass: "row justify-content-end px-3"
  }, [_c('div', {
    staticClass: "col-4"
  }, [_c('SharedButton', {
    staticClass: "s-btn-outline-primary",
    on: {
      "click": function click($event) {
        _vm.showCardEncrypt = true;
        _vm.showReset = false;
      }
    }
  }, [_vm._v("重置載具")])], 1)]) : _vm._e()]);
}
var staticRenderFns = []

export { render, staticRenderFns }